var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMexico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_650_1482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 38C29.4934 38 38 29.4934 38 19C38 8.50659 29.4934 0 19 0C8.50659 0 0 8.50659 0 19C0 29.4934 8.50659 38 19 38Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9999 19C37.9999 11.4672 33.6162 4.9585 27.2607 1.88525V36.1146C33.6162 33.0414 37.9999 26.5327 37.9999 19Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 18.9999C0 26.5327 4.38373 33.0414 10.7392 36.1146V1.88525C4.38373 4.9585 0 11.4672 0 18.9999Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0435 18.9998C14.0435 21.7372 16.2626 23.9564 19 23.9564C21.7374 23.9564 23.9566 21.7372 23.9566 18.9998V17.3477H14.0435V18.9998Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6086 15.6956H20.652C20.652 14.7832 19.9123 14.0435 18.9998 14.0435C18.0874 14.0435 17.3477 14.7832 17.3477 15.6956H12.3911C12.3911 16.6082 13.1859 17.3478 14.0983 17.3478H14.0433C14.0433 18.2603 14.783 19 15.6955 19C15.6955 19.9125 16.4351 20.6522 17.3477 20.6522H20.652C21.5646 20.6522 22.3042 19.9125 22.3042 19C23.2167 19 23.9564 18.2603 23.9564 17.3478H23.9013C24.8138 17.3478 25.6086 16.6082 25.6086 15.6956Z",
    fill: "#FF9811"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_650_1482"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMexico);
export default __webpack_public_path__ + "static/media/mexico.23f94989bc9b97268c6454220a165e68.svg";
export { ForwardRef as ReactComponent };